module.exports = __webpack_public_path__ + "07f382e18efa8b33ea6cf2aa12212822.svg";